module.exports = __webpack_public_path__ + "static/img/bgw.5675ada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgw.png
// module id = SUUS
// module chunks = 0